'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _class, _temp;

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = require('fbjs/lib/warning');

var _warning2 = _interopRequireDefault(_warning);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _ajaxShape = require('./ajaxShape');

var _ajaxShape2 = _interopRequireDefault(_ajaxShape);

var _poller = require('./poller');

var _poller2 = _interopRequireDefault(_poller);

var _substitute2 = require('../core/substitute');

var _substitute3 = _interopRequireDefault(_substitute2);

var _messages = require('../core/messages');

var _messages2 = _interopRequireDefault(_messages);

var _isPlainObject = require('../core/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop(d) {
  return d;
};
var empty = {};
/**
 * # Ajax模块
 *
 * ### 静态属性
 *
 * |        名称         |          描述          |
 * |:       ------          |         ------          |
 * | headers | 全局的Header配置, 默认取值`window.ajaxHeader` |
 * | delimeter | 请求url默认支持插值替换，`delimeter`是插值变量的语法 |
 * | normalize | 请求url插值替换，是否都走data属性, 默认为`false` |
 * | stringify | post request with JSON data in application/x-www-form-urlencoded, 默认为`false` |
 * | beforeRequest(ajaxOptions) | 请求之前的钩子函数 |
 * | beforeResponse(response, ajaxOptions, xhr) | 请求成功后处理response对象的钩子函数 |
 * | afterResponse(result, ajaxOptions, xhr) | 请求成功后处理接口结果数据的钩子函数 |
 */
var Ajax = (_temp = _class = function () {
  // #! 统一走data做过滤
  function Ajax() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, Ajax);
    this._setting = {
      query: {}
    };

    if (options.origin) {
      this._uri = _url2.default.parse(options.origin);
      delete options.origin;
    }
    for (var key in options) {
      this.set(key, options[key]);
    }
  }

  /**
   * ### 方法
   *
   * | 方法 | 参数类型 | 描述 |
   * |: ------ |: ------ |: ------ |
   * | setHeader(headers) | headers `Object` | 设置全局的Header配置 |
   * | set(name[, value]) | name `String`, value `any` | 设置或者获取静态属性及方法, 前提是这个静态属性是存在的 |
   * | beforeRequest(fn) | fn `Function` | 请求之前的处理 |
   * | beforeResponse(fn) | fn `Function` | 接口结果预处理 |
   * | afterResponse(fn) | fn `Function` | 接口结果后处理 |
   * | request(options) | options `Object` | 接口请求处理逻辑 |
   */

  // #! delimeter = /\\?\{([^{}]+)\}/g;


  (0, _createClass3.default)(Ajax, [{
    key: 'setHeader',
    value: function setHeader(headers) {
      if (this._setting.headers) {
        (0, _warning2.default)(false, _messages2.default.duplicateProp, 'setHeader', typeof headers === 'undefined' ? 'undefined' : (0, _typeof3.default)(headers), 'headers', 'Beatle.Ajax');
      }
      this._setting.headers = headers;
    }
  }, {
    key: 'beforeRequest',
    value: function beforeRequest(fn) {
      if (this._setting.beforeRequest) {
        (0, _warning2.default)(false, _messages2.default.duplicateProp, 'beforeRequest', typeof fn === 'undefined' ? 'undefined' : (0, _typeof3.default)(fn), 'beforeRequest', 'Beatle.Ajax');
      }
      this._setting.beforeRequest = fn;
    }
  }, {
    key: 'beforeResponse',
    value: function beforeResponse(fn) {
      if (this._setting.beforeResponse) {
        (0, _warning2.default)(false, _messages2.default.duplicateProp, 'beforeResponse', typeof fn === 'undefined' ? 'undefined' : (0, _typeof3.default)(fn), 'beforeResponse', 'Beatle.Ajax');
      }
      this._setting.beforeResponse = fn;
    }
  }, {
    key: 'afterResponse',
    value: function afterResponse(fn) {
      if (this._setting.afterResponse) {
        (0, _warning2.default)(false, _messages2.default.duplicateProp, 'afterResponse', typeof fn === 'undefined' ? 'undefined' : (0, _typeof3.default)(fn), 'afterResponse', 'Beatle.Ajax');
      }
      this._setting.afterResponse = fn;
    }

    /**
     * ### 设置和获取静态属性或静态方法
     *
     * ```
     * // 获取全局headers
     * const headers = app.getAjax().set('headers');
     * // 设置beforeRequest
     * app.getAjax().set('beforeRequest', function(ajaxOptions){
     *  //...
     * });
     *
     * // 以上是通过Beatle实例来设置对应的ajax实例的全局配置。
     * // 以下是通过Ajax对象来设置，所有应用公用的全局配置
     * Ajax.headers = {};
     * Ajax.beforeRequest = function(ajaxOptions){
     *  //...
     * }
     *
     * // 如果只是设置Ajax实例的全局配置，比如app.getAjax().set(name, value)
     * // 我们也可以通过Ajax模块自行初始化和设置
     * // 在初始化设置
     * const ajax = new Ajax({
     *  headers: {...}
     * });
     * // 通过实例方法进行设置
     * ajax.set('beforeRequest', function(ajaxOptions){})
     * ```
     * > 目前支持的静态属性及方法为：`headers`, `delimeter`, `normalize`, `beforeRequest`, `beforeResponse`, `afterResponse`
     */

  }, {
    key: 'set',
    value: function set(name, value) {
      if (Ajax[name] === undefined) {
        (0, _warning2.default)(false, _messages2.default.invalidProp, 'set', name, 'headers, delimeter, normalize, stringify, beforeRequest, beforeResponse, afterResponse', 'Beatle.Ajax');
      } else {
        if (value === undefined || value === null) {
          value = this._setting[name] || Ajax[name];
          if (value === noop) {
            return null;
          } else {
            return value;
          }
        } else {
          if (this._setting[name] && (this._setting[name] !== noop || this._setting[name] !== empty)) {
            (0, _warning2.default)(false, _messages2.default.duplicateProp, 'set', name, 'headers, delimeter, normalize, stringify, beforeRequest, beforeResponse, afterResponse', 'Beatle.Ajax');
          }
          this._setting[name] = value;
        }
      }
    }
  }, {
    key: '_substitute',
    value: function _substitute(ajaxOptions, mutable) {
      var iquery = this.set('query');
      var delimeter = this.set('delimeter');
      var normalize = ajaxOptions.normalize === undefined ? this.set('normalize') : ajaxOptions.normalize;
      ajaxOptions.originUrl = ajaxOptions.url;
      var data = void 0;
      if (normalize) {
        // #! query merge to originData
        ajaxOptions.originData = Object.assign({}, iquery);
        if (mutable) {
          Object.assign(ajaxOptions.originData, ajaxOptions.data);
        } else {
          if (ajaxOptions.data) {
            if (ajaxOptions.data.forEach) {
              ajaxOptions.data.forEach(function (value, key) {
                ajaxOptions.originData[key] = value;
              });
            } else {
              (0, _forEach2.default)(ajaxOptions.data, function (value, key) {
                ajaxOptions.originData[key] = value;
              });
            }
          }
        }
        data = Object.assign(ajaxOptions.originData, ajaxOptions.params);
        ajaxOptions.url = (0, _substitute3.default)(ajaxOptions.url, ajaxOptions.originData, function (n) {
          return delete ajaxOptions.originData[n];
        }, delimeter);
      } else {
        // #! originData equals to data;
        ajaxOptions.originData = ajaxOptions.data;
        data = Object.assign({}, iquery, ajaxOptions.params);
        ajaxOptions.url = (0, _substitute3.default)(ajaxOptions.url, Object.keys(data).length ? data : ajaxOptions.originData, null, delimeter);
      }
    }

    // #! 走params形式包装ajaxOptions

  }, {
    key: '_formatQuery',
    value: function _formatQuery(ajaxOptions, needMerge) {
      var _this = this;

      var data = ajaxOptions.originData;
      // 解析url，并把queryStr解析为object
      var u = _url2.default.parse(ajaxOptions.url, true);
      if (this._uri && !u.host) {
        ['protocol', 'hostname', 'port'].forEach(function (key) {
          return u[key] = _this._uri[key];
        });
        var pathname = this._uri.pathname === '/' ? '' : this._uri.pathname || '';
        u.pathname = pathname + u.pathname;
      }
      if (needMerge) {
        // 合并ajaxOptions.data到query，重复的key被data中的值替换
        u.query = Object.assign(u.query || {}, data);
        // 去除search属性，在format函数中，如果存在search，那么query解析为queryStr不被接收
        var query = _qs2.default.stringify(u.query, ajaxOptions.qsOption);
        u.search = query && '?' + query || '';
        delete u.query;
      }
      // 得到最后的url
      return _url2.default.format(u);
    }

    /**
     * ### 配置预处理
     *
     * 1. method改大写，默认是`GET`
     * 2. data值默认为{}
     * 3. headers同全局的`headers`做合并
     * 4. 转为原生Fetch需要的配置项
     */

  }, {
    key: '_prepareOption',
    value: function _prepareOption(ajaxOptions) {
      if (ajaxOptions.method) {
        ajaxOptions.method = ajaxOptions.method.toUpperCase();
      } else {
        ajaxOptions.method = 'GET';
      }

      var iHeaders = {};
      var mutable = ajaxOptions.mutable === false ? false : ajaxOptions.data === undefined || (0, _isPlainObject2.default)(ajaxOptions.data) || Array.isArray(ajaxOptions.data);
      // 替换字符串变量，只有header不填
      this._substitute(ajaxOptions, mutable);

      // headers是否存在json处理
      var isJsonHeader = iHeaders['Content-Type'] && iHeaders['Content-Type'].indexOf('application/json') > -1;
      var data = mutable ? ajaxOptions.originData : ajaxOptions.data;
      // 如果没有指定headers，则把默认的header合并进来
      if (!ajaxOptions.headers) {
        Object.assign(iHeaders, this.set('headers'));
      }

      var credential = ajaxOptions.credential || 'same-origin';
      var extraOption = {};
      // see: https://github.com/github/fetch/issues/263
      var stringify = ajaxOptions.stringify || this.set('stringify');
      // 如果存在json处理，或者method不为GET、DELETE
      if (isJsonHeader || !(ajaxOptions.method === 'GET' || ajaxOptions.method === 'DELETE')) {
        if (mutable) {
          extraOption.body = stringify ? _qs2.default.stringify(data, ajaxOptions.qsOption) : JSON.stringify(data);
          if (!ajaxOptions.headers) {
            iHeaders['Content-Type'] = stringify ? 'application/x-www-form-urlencoded' : 'application/json; charset=utf-8';
          }
        } else {
          extraOption.body = data;
        }
        extraOption.url = this._formatQuery(ajaxOptions);
      } else {
        extraOption.url = this._formatQuery(ajaxOptions, true);
      }
      delete ajaxOptions.data;
      delete ajaxOptions.params;
      delete ajaxOptions.stringify;
      delete ajaxOptions.normalize;
      delete ajaxOptions.mutable;
      delete ajaxOptions.originData;
      /**
       * ### 常用配置
       *
       * | 属性 | 描述 |
       * |: ------ |: ------ |
       * | url | 请求地址 |
       * | method | 请求方法 |
       * | headers | 请求头部 |
       * | mode | 请求模式，参考 `cors`, `no-cors`, `same-origin`, 默认`no-cors` |
       * | credentials | 请求凭证, 参考`omit`, `same-origin`, `include`, 默认是`same-origin`, 有凭证才带cookie |
       * | cache | 缓存模式，参考 `default`, `reload`, `no-cache`, 默认`default` |
       *
       * > see: https://developer.mozilla.org/zh-CN/docs/Web/API/Request
       */
      return Object.assign(ajaxOptions, {
        credentials: credential,
        headers: Object.assign({}, ajaxOptions.headers, iHeaders)
      }, extraOption);
    }

    /**
     * ### 接口调用具体实现
     *
     * ```
     *  const ajax1 = new Ajax();
     *  // 场景1： 常规的接口调用
     *  const promise = ajax1.request({
     *    url: '/api/entity/query/list',
     *    data: {
     *      page: 1,
     *      paeSize: 10
     *    },
     *    callback: (err, res) => {
     *      // err是错误时有值，res是正确时接口的真实数据
     *    }
     *  });
     *  // 场景2：接口请求支持占位符变量
     *  ajax1.request({
     *    url: '/api/entity/:id?status=:status',
     *    data: {
     *      id: 10
     *    },
     *    params: {
     *      status: 1
     *    }
     *  });
     *  // 场景3：占位变量通通用data属性来替换
     *  ajax1.request({
     *    url: '/api/entity/:id?status=:status',
     *    data: {
     *      id: 10,
     *      status: 1
     *    },
     *    normalize: true
     *  });
     * // 这种方式变成通用设置
     *  const ajax2 = new Ajax({normalize: true});
     *  ajax2.request({
     *    url: '/api/entity/:id?status=:status',
     *    data: {
     *      id: 10,
     *      status: 1
     *    }
     *  });
     * ```
     */

  }, {
    key: 'request',
    value: function request(ajaxOptions) {
      var _this2 = this;

      _propTypes2.default.checkPropTypes(_ajaxShape2.default, ajaxOptions, 'request', 'Beatle.Ajax');

      ajaxOptions = this._prepareOption(ajaxOptions);
      var beforeRequest = ajaxOptions.beforeRequest;
      var beforeResponse = ajaxOptions.beforeResponse;
      var afterResponse = ajaxOptions.afterResponse;
      var catchError = ajaxOptions.catchError;
      delete ajaxOptions.beforeRequest;
      delete ajaxOptions.beforeResponse;
      delete ajaxOptions.afterResponse;
      delete ajaxOptions.catchError;

      beforeRequest = beforeRequest || this.set('beforeRequest');
      var processorResult = beforeRequest(ajaxOptions);
      if (processorResult === false) {
        return Promise.reject(false);
      }

      var xhr = void 0;
      if (processorResult && typeof processorResult.then === 'function') {
        xhr = processorResult;
      } else {
        /**
        * ### Fetch请求
        *
        * > see: https://fetch.spec.whatwg.org/#methods
        * > see: https://developer.mozilla.org/zh-CN/docs/Web/API/Fetch_API/Using_Fetch
        *
        * ### 和jQuery.ajax不同之处
        *
        * * 当接收到一个代表错误的 HTTP 状态码时，从 fetch()返回的 Promise 不会被标记为 reject， 即使该 HTTP 响应的状态码是 404 或 500。相反，它会将 Promise 状态标记为 resolve （但是会将 resolve 的返回值的 ok 属性设置为 false ），  仅当网络故障时或请求被阻止时，才会标记为 reject。
        * * 默认情况下, fetch 不会从服务端发送或接收任何 cookies, 如果站点依赖于用户 session，则会导致未经认证的请求（要发送 cookies，必须设置 credentials 选项）
        *
        * > Fetch API 的支持情况，可以通过检测 Headers、Request、Response 或 fetch() 是否在 Window 或 Worker 域中
        */
        xhr = (0, _isomorphicFetch2.default)(ajaxOptions.url, ajaxOptions).then(function (response) {
          beforeResponse = beforeResponse || _this2.set('beforeResponse');
          return beforeResponse(response, ajaxOptions, xhr);
        });
        xhr.catch(function (err) {
          callback && callback(err, null, xhr);
        });
      }
      var callback = ajaxOptions.callback;
      xhr = xhr.then(function (response) {
        afterResponse = afterResponse || _this2.set('afterResponse');

        var result = afterResponse(response, ajaxOptions, xhr);
        if (result instanceof Error) {
          // #! callback(result || new Error(messages.abortReponse), null, xhr);
          throw result;
        } else if (result === false) {
          return result;
        } else {
          if (result === undefined) {
            result = response;
          }
          callback && callback(null, result, xhr);
        }
        return result;
      }, function (err) {
        return callback && callback(err, null, xhr);
      });
      catchError = catchError || this.set('catchError');
      if (catchError) {
        xhr = xhr.catch(function (err) {
          catchError(err);
          window.console.error(err);
          return Promise.reject(err);
        });
      }
      return xhr;
    }
  }, {
    key: 'poller',
    value: function poller(pollerOptions) {
      return new _poller2.default(pollerOptions);
    }
  }]);
  return Ajax;
}(), _class.headers = window.ajaxHeader || null, _class.delimeter = /:(\w+)/g, _class.normalize = false, _class.stringify = false, _class.catchError = null, _class.beforeRequest = noop, _class.afterResponse = noop, _class.beforeResponse = function (response, ajaxOptions) {
  if (response.ok || response.status === 304) {
    try {
      /**
       * ### 基于Response对象，dataType取值
       *
       * | 取值 | 描述 |
       * |: ------ |: ------ |
       * | arrayBuffer | 解析为`ArrayBuffer`的promise对象 |
       * | blob | 解析为`Blob`的promise对象, `URL.createObjectURL(Blob)`转为base64 |
       * | formData | 解析为`FormData`的promise对象 |
       * | json | 解析为`Json`的promise对象 |
       * | text | 解析为`USVString`的promise对象 |
       *
       * > see: https://developer.mozilla.org/zh-CN/docs/Web/API/Response
       */
      if (ajaxOptions.dataType === undefined) {
        response = response.json();
      } else if (ajaxOptions.dataType && typeof response[ajaxOptions.dataType] === 'function') {
        response = response[ajaxOptions.dataType]();
      } else {
        response = response.text();
      }
    } catch (e) {
      response = e;
    }
  } else {
    var error = new Error(response.statusText);
    error.response = response.json ? response.json() : response;
    response = error;
  }

  return response;
}, _class.request = function (ajaxOptions) {
  return new Ajax().request(ajaxOptions);
}, _class.query = empty, _temp);

/**
 * ### mixin方法
 *
 * |        方法         |          描述          |
 * |:       ------          |         ------          |
 */

exports.default = Ajax;
var mixinMethods = ['get', 'delete', 'post', 'put', 'patch'];

mixinMethods.forEach(function (method) {
  /**
   * ```
   *  ajax.get(url, data);
   *  ajax.get(url, data, callback);
   *  ajax.get(url, data, callback, dataType);
   *  ajax.get(url, data, options);
   *  ajax.get(url, data, options, callback);
   * ```
   */
  Ajax.prototype[method] = function (url, data, callback, dataType) {
    var ajaxOptions = {
      method: method,
      url: url,
      data: data
    };
    if ((0, _isPlainObject2.default)(callback)) {
      Object.assign(ajaxOptions, callback);
      if (typeof dataType === 'function') {
        callback = dataType;
        dataType = null;
      }
    } else if (callback) {
      ajaxOptions.callback = callback;
      ajaxOptions.dataType = dataType;
    }
    return this.request(ajaxOptions);
  };
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/ajax.js
// module id = 32
// module chunks = 0